import { useState } from 'react'

export function useClipboard(timeout = 2000) {
  const [copied, setCopied] = useState(null)

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(text)
      setTimeout(() => setCopied(null), timeout)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  return { copied, copy }
}
